import { schema } from "normalizr";

const dcStatuses = new schema.Entity("dcStatuses");

export default {
    DC_STATUSES: [dcStatuses]
};
